import { applySearchFilter } from "../../shared/controlEntitiesUtils";
import {
  createFallbackSimpleEntitiesFromComplexIds,
  mergeEntitiesByType,
} from "../../shared/entityFallbackUtils";
import { MisconfigStatusTab } from "../../tables/MisconfigStatusTabs";

const groupEntitiesByStatus = (entitiesByType, misconfiguration) => {
  return Object.entries(entitiesByType).reduce(
    (acc, [entityType, entities]) => {
      acc[entityType] = {
        [MisconfigStatusTab.INCLUDED]: [],
        [MisconfigStatusTab.EXCLUDED]: [],
        [MisconfigStatusTab.SNOOZED]: [],
      };

      const excludedAffectedEntities =
        misconfiguration?.affected_entities?.filter((affectedEntity) => {
          return affectedEntity.is_excluded;
        });
      const excludedAffectedEntityIds = excludedAffectedEntities?.map(
        (affectedEntity) => {
          return affectedEntity.entity_id;
        }
      );

      const snoozedAffectedEntities =
        misconfiguration?.affected_entities?.filter((affectedEntity) => {
          return affectedEntity.is_snoozed;
        });
      const snoozedAffectedEntityIds = snoozedAffectedEntities?.map(
        (affectedEntity) => {
          return affectedEntity.entity_id;
        }
      );

      entities.forEach((entity) => {
        const isExcluded = excludedAffectedEntityIds.includes(entity.entity_id);
        const isSnoozed = snoozedAffectedEntityIds.includes(entity.entity_id);
        acc[entityType][
          isExcluded
            ? MisconfigStatusTab.EXCLUDED
            : isSnoozed
            ? MisconfigStatusTab.SNOOZED
            : MisconfigStatusTab.INCLUDED
        ].push(entity);
      });

      return acc;
    },
    {}
  );
};

export const groupEntitiesByTypeAndStatus = (
  response,
  misconfiguration,
  searchText = "",
  appliedFilters = {},
  assets = [],
  controlId = null,
  trackEvent = null
) => {
  const affectedEntityIds = misconfiguration?.affected_entity_ids || [];

  const fallbackSimpleEntities = createFallbackSimpleEntitiesFromComplexIds(
    affectedEntityIds,
    response?.complex,
    controlId,
    trackEvent,
    "affected entities not found in DB"
  );

  const allEntitiesByType = mergeEntitiesByType(
    response?.complex || {},
    response?.simple || {},
    fallbackSimpleEntities
  );

  if (Object.keys(allEntitiesByType).length === 0) return null;

  const searchedEntitiesByType = applySearchFilter(
    allEntitiesByType,
    searchText,
    appliedFilters,
    assets
  );

  return groupEntitiesByStatus(searchedEntitiesByType, misconfiguration);
};
